module.exports = __webpack_public_path__ + "img/service03.7f34457f.jpg";